import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AccCohortPageService } from '../acc-cohort.page.service';
import { AccCompletedEngagementsViewPart } from './engagements/completed-engagements/acc-completed-engagements-view.part';
import { AccOpenEngagementsViewPart } from './engagements/open-engagements/acc-open-engagements-view.part';
import { AccScheduledFollowUpsViewPart } from './engagements/scheduled-follow-ups/acc-scheduled-follow-ups-view.part';
import { AccGoalsAndProgressViewPart } from './goals-and-progress/goals-and-progress-view.part';
import { AccEntrepreneursViewPart } from './people/entrepreneurs/acc-entrepreneurs-view.part';
import { AccMentorsViewPart } from './people/mentors/acc-mentors-view.part';
import { AccSpecialistsViewPart } from './people/specialists/acc-specialists-view.part';
import { AccTeamsViewPart } from './people/teams/acc-teams-view.part';
import { AccVenturesViewPart } from './people/ventures/acc-ventures-view.part';


@Component({
	selector: 'acc-cohort-views-part',
	standalone: true,
	imports: [
		AccTeamsViewPart,
		AccVenturesViewPart,
		AccEntrepreneursViewPart,
		AccMentorsViewPart,
		AccSpecialistsViewPart,
		AccOpenEngagementsViewPart,
		AccCompletedEngagementsViewPart,
		AccScheduledFollowUpsViewPart,
		AccGoalsAndProgressViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-cohort-views.part.html',
})
export class AccCohortViewsPart implements OnInit {

	public pageService = inject(AccCohortPageService);

	ngOnInit() {
		const a = 1;
		// this.service.initializeUrl();
	}
}